import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=52e0834c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e0834c')) {
      api.createRecord('52e0834c', component.options)
    } else {
      api.reload('52e0834c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=52e0834c&", function () {
      api.rerender('52e0834c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vb8QIjivVl6o/JS/imageCarousel.vue"
export default component.exports